import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { IImageCategory, IImageLibrary, IImagePublic } from "./types/_image";
import { PaginationResponse, ResponseData } from "./types/_public";
const api = new APIClient();

const path = '/image-categories';
const path_image_library = '/media-files';
const path_image_public = '/images';
const imageApi = {
  imageCategories(params: any): Promise<AxiosResponse<ResponseData<IImageCategory[]> & PaginationResponse, any>> {
    const url = `${path}`
    return api.get(url, params)
  },
  getImageCategory(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<IImageCategory>, any>> {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },
  allImageCategory(params: any = {}): Promise<AxiosResponse<ResponseData<IImageCategory[]>, any>> {
    const url = `masters/image-categories`
    return api.get(url, params)
  },
  postImageCategory(dataForm: any): Promise<AxiosResponse<ResponseData<IImageCategory>, any>> {
    const url = `${path}/bulk`;
    const formData = new FormData();
    formData.append(`name`, dataForm?.name);
    formData.append(`urls`, dataForm?.urls);
    if (dataForm.files) {
      formData.append('files', dataForm.files);
    }
    return api.post(url, formData, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  postSiteImageCategory(dataForm: any): Promise<AxiosResponse<ResponseData<IImageCategory>, any>> {
    const url = `/image-sites`;
    return api.post(url, dataForm);
  },
  putImageCategory(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IImageCategory>, any>> {
    const url = `${path}/${id}`;
    const formData = { name: dataForm?.name, urls: dataForm?.urls };
    return api.put(url, formData)
  },
  putImportImageCategory(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IImageCategory>, any>> {
    const url = `${path}/${id}/import`;
    const formData = new FormData();
    if (dataForm.files) {
      formData.append('files', dataForm.files);
    }
    return api.put(url, formData, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  putImportImageCategoryLevel1(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IImageCategory>, any>> {
    const url = `${path}/bulk`;
    const formData = new FormData();
    formData.append('category_depth_1_id', `${id}`);
    if (dataForm.files) {
      formData.append('files', dataForm.files);
    }
    return api.post(url, formData, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  deleteImageCategory(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IImageCategory>, any>> {
    const url = `${path}/${id}`;
    return api.delete(url, dataForm)
  },

  getImageSearchByCategory(params: any = {}): Promise<AxiosResponse<ResponseData<IImageCategory>, any>> {
    const url = `/image-sites`;
    return api.get(url, params)
  },
  postConvertToCdn(dataForm: any): Promise<AxiosResponse<ResponseData<IImageCategory>, any>> {
    const url = `/image-convert`;//`/utilities/convert-cdn`;
    return api.post(url, dataForm);
  },

  imageLibraries(params: any): Promise<AxiosResponse<ResponseData<IImageLibrary[]> & PaginationResponse, any>> {
    const url = `${path_image_library}`
    return api.get(url, params)
  },
  getImageLibrary(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<IImageLibrary>, any>> {
    const url = `${path_image_library}/${id}`;
    return api.get(url, params)
  },
  postImageLibrary(dataForm: any): Promise<AxiosResponse<ResponseData<IImageLibrary>, any>> {
    const url = `${path_image_library}`;
    return api.post(url, dataForm);
  },
  putImageLibrary(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IImageLibrary>, any>> {
    const url = `${path_image_library}/${id}`;
    return api.put(url, dataForm)
  },
  patchImageLibrary(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IImageLibrary>, any>> {
    const url = `${path_image_library}/${id}/trigger`;
    return api.patch(url, dataForm)
  },
  deleteImageLibrary(dataForm: any): Promise<AxiosResponse<ResponseData<IImageLibrary>, any>> {
    const url = `${path_image_library}`;
    return api.delete(url, {
      data: dataForm
    })
  },
  importImageBulkByExcel(dataForm: any): Promise<AxiosResponse<ResponseData<IImageLibrary>, any>> {
    const url = `${path_image_library}/import-v2`;
    const formData = new FormData();
    if (dataForm.files) {
      formData.append('files', dataForm.files);
    }
    if (dataForm.email) {
      formData.append('email', dataForm.email);
    }
    return api.post(url, formData, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getTemplateSampleImageBulkExcel(params: any): Promise<AxiosResponse<ResponseData<IImageLibrary[]> & PaginationResponse, any>> {
    const url = `/masters/template-files/media-manage-import`
    return api.get(url, params)
  },
  getAllImageLibraryTags(params: any): Promise<AxiosResponse<ResponseData<IImageLibrary[]> & PaginationResponse, any>> {
    const url = `/masters/tags`
    return api.get(url, params)
  },


  imagePublics(params: any): Promise<AxiosResponse<ResponseData<IImagePublic[]> & PaginationResponse, any>> {
    const url = `${path_image_public}`
    return api.get(url, params)
  },
  getImagePublic(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<IImagePublic>, any>> {
    const url = `${path_image_public}/${id}`;
    return api.get(url, params)
  },
  postImagePublic(dataForm: any): Promise<AxiosResponse<ResponseData<IImagePublic>, any>> {
    const url = `${path_image_public}`;
    return api.post(url, dataForm);
  },
  putImagePublic(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IImagePublic>, any>> {
    const url = `${path_image_public}/${id}`;
    return api.put(url, dataForm)
  },
  patchImagePublic(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IImagePublic>, any>> {
    const url = `${path_image_public}/${id}/download`;
    return api.patch(url, dataForm)
  },
  deleteImagePublic(dataForm: any): Promise<AxiosResponse<ResponseData<IImagePublic>, any>> {
    const url = `${path_image_public}`;
    return api.delete(url, {
      data: dataForm
    })
  },
  importImagePublicBulkByExcel(dataForm: any): Promise<AxiosResponse<ResponseData<IImagePublic>, any>> {
    const url = `${path_image_public}/import`;
    const formData = new FormData();
    if (dataForm.files) {
      formData.append('files', dataForm.files);
    }
    if (dataForm.email) {
      formData.append('email', dataForm.email);
    }
    return api.post(url, formData, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getTemplateSampleImagePublicBulkExcel(params: any): Promise<AxiosResponse<ResponseData<IImagePublic[]> & PaginationResponse, any>> {
    const url = `/masters/template-files/media-manage-import`
    return api.get(url, params)
  },
  getAllImagePublicTags(params: any): Promise<AxiosResponse<ResponseData<IImagePublic[]> & PaginationResponse, any>> {
    const url = `/masters/tags`
    return api.get(url, params)
  },
}
export default imageApi
